import { JSONSchemaType } from "ajv"
import validateConstant, {
  e入力パターン,
} from "../../../constant/validateConstant"
import util from "../../../ts/util"
import { TTumiorosisakiPostReq, TTumiorosisakiPutReq } from "./TTumiorosisaki"

export const tumiorosisakiPostReqSchema: JSONSchemaType<TTumiorosisakiPostReq> =
  {
    type: "object",
    properties: {
      荷主コード: {
        type: "string",
        minLength: 1,
        maxLength: validateConstant.LENGTH.荷主コード,
        title: "荷主コード",
        errorMessage: util.stringErrorMessage("荷主コード", {
          required: true,
          maxLength: validateConstant.LENGTH.荷主コード,
        }),
      },
      積卸先コード: {
        type: "string",
        minLength: 1,
        maxLength: validateConstant.LENGTH.積卸先コード,
        pattern: validateConstant.PATTERN.英数字のみ,
        title: "積卸先コード",
        errorMessage: util.stringErrorMessage("積卸先コード", {
          required: true,
          maxLength: validateConstant.LENGTH.積卸先コード,
          pattern: e入力パターン.英数字のみ,
        }),
      },
      積卸先名: {
        type: "string",
        minLength: 1,
        maxLength: validateConstant.LENGTH.一般名称,
        title: "積卸先名",
        errorMessage: util.stringErrorMessage("積卸先名", {
          required: true,
          maxLength: validateConstant.LENGTH.一般名称,
        }),
      },
      積卸先名カナ: {
        type: "string",
        maxLength: validateConstant.LENGTH.一般カナ名称,
        title: "積卸先名カナ",
        nullable: true,
        errorMessage: util.stringErrorMessage("積卸先名カナ", {
          required: false,
          maxLength: validateConstant.LENGTH.一般カナ名称,
        }),
      },
      積卸先略称: {
        type: "string",
        maxLength: validateConstant.LENGTH.一般略称,
        title: "積卸先略称",
        nullable: true,
        errorMessage: util.stringErrorMessage("積卸先略称", {
          required: false,
          maxLength: validateConstant.LENGTH.一般略称,
        }),
      },
      都道府県コード: {
        type: "string",
        minLength: 1,
        maxLength: validateConstant.LENGTH.都道府県コード,
        title: "都道府県コード",
        errorMessage: util.stringErrorMessage("都道府県", {
          required: true,
          maxLength: validateConstant.LENGTH.都道府県コード,
        }),
      },
      住所２: {
        type: "string",
        nullable: true,
        maxLength: validateConstant.LENGTH.住所２,
        title: "住所２",
        errorMessage: util.stringErrorMessage("市区町村", {
          required: false,
          maxLength: validateConstant.LENGTH.住所２,
        }),
      },
      住所３: {
        type: "string",
        nullable: true,
        maxLength: validateConstant.LENGTH.住所３,
        title: "住所３",
        errorMessage: util.stringErrorMessage("町名番地", {
          required: false,
          maxLength: validateConstant.LENGTH.住所３,
        }),
      },
      郵便番号: {
        type: "string",
        maxLength: validateConstant.LENGTH.郵便番号,
        nullable: true,
        title: "郵便番号",
        errorMessage: util.stringErrorMessage("郵便番号", {
          maxLength: validateConstant.LENGTH.郵便番号,
        }),
      },
      電話番号: {
        type: "string",
        maxLength: validateConstant.LENGTH.電話番号,
        nullable: true,
        title: "電話番号",
        errorMessage: util.stringErrorMessage("電話番号", {
          maxLength: validateConstant.LENGTH.電話番号,
        }),
      },
      FAX番号: {
        type: "string",
        maxLength: validateConstant.LENGTH.電話番号,
        nullable: true,
        title: "FAX番号",
        errorMessage: util.stringErrorMessage("FAX番号", {
          maxLength: validateConstant.LENGTH.電話番号,
        }),
      },
      積卸先担当者: {
        type: "string",
        maxLength: validateConstant.LENGTH.一般名称,
        nullable: true,
        title: "積卸先担当者",
        errorMessage: util.stringErrorMessage("積卸先担当者", {
          required: false,
          maxLength: validateConstant.LENGTH.一般名称,
        }),
      },
      客先台帳ファイル名: {
        type: "string",
        maxLength: validateConstant.LENGTH.一般名称,
        nullable: true,
        title: "客先台帳ファイル名",
        errorMessage: util.stringErrorMessage("客先台帳ファイル名", {
          required: false,
          maxLength: validateConstant.LENGTH.一般名称,
        }),
      },
      客先台帳: {
        type: "object",
        nullable: true,
        title: "客先台帳",
      },
    },
    required: ["荷主コード", "積卸先コード", "積卸先名", "都道府県コード"],
    errorMessage: {
      required: util.JsonSchemeRequiredErrorMessages([
        "荷主コード",
        "積卸先コード",
        "積卸先名",
        "都道府県コード",
      ]),
    },
  }

export const tumiorosisakiPutReqSchema: JSONSchemaType<TTumiorosisakiPutReq> = {
  type: "object",
  properties: {
    荷主コード: {
      type: "string",
      minLength: 1,
      maxLength: validateConstant.LENGTH.荷主コード,
      title: "荷主コード",
      errorMessage: util.stringErrorMessage("荷主コード", {
        required: true,
        maxLength: validateConstant.LENGTH.荷主コード,
      }),
    },
    積卸先コード: {
      type: "string",
      minLength: 1,
      maxLength: validateConstant.LENGTH.積卸先コード,
      pattern: validateConstant.PATTERN.英数字のみ,
      title: "積卸先コード",
      errorMessage: util.stringErrorMessage("積卸先コード", {
        required: true,
        maxLength: validateConstant.LENGTH.一般名称,
        pattern: e入力パターン.英数字のみ,
      }),
    },
    積卸先名: {
      type: "string",
      minLength: 1,
      maxLength: validateConstant.LENGTH.一般名称,
      title: "積卸先名",
      errorMessage: util.stringErrorMessage("積卸先名", {
        required: true,
        maxLength: validateConstant.LENGTH.一般名称,
      }),
    },
    積卸先名カナ: {
      type: "string",
      nullable: true,
      maxLength: validateConstant.LENGTH.一般カナ名称,
      title: "積卸先名カナ",
      errorMessage: util.stringErrorMessage("積卸先名カナ", {
        required: false,
        maxLength: validateConstant.LENGTH.一般カナ名称,
      }),
    },
    積卸先略称: {
      type: "string",
      nullable: true,
      minLength: 1,
      maxLength: validateConstant.LENGTH.一般略称,
      title: "積卸先略称",
      errorMessage: util.stringErrorMessage("積卸先略称", {
        required: false,
        maxLength: validateConstant.LENGTH.一般略称,
      }),
    },
    都道府県コード: {
      type: "string",
      minLength: 1,
      maxLength: validateConstant.LENGTH.都道府県コード,
      title: "都道府県コード",
      errorMessage: util.stringErrorMessage("都道府県", {
        required: true,
        maxLength: validateConstant.LENGTH.都道府県コード,
      }),
    },
    住所２: {
      type: "string",
      nullable: true,
      maxLength: validateConstant.LENGTH.住所２,
      title: "住所２",
      errorMessage: util.stringErrorMessage("市区町村", {
        required: false,
        maxLength: validateConstant.LENGTH.住所２,
      }),
    },
    住所３: {
      type: "string",
      nullable: true,
      maxLength: validateConstant.LENGTH.住所３,
      title: "住所３",
      errorMessage: util.stringErrorMessage("町名番地", {
        required: false,
        maxLength: validateConstant.LENGTH.住所３,
      }),
    },
    郵便番号: {
      type: "string",
      maxLength: validateConstant.LENGTH.郵便番号,
      nullable: true,
      title: "郵便番号",
      errorMessage: util.stringErrorMessage("郵便番号", {
        maxLength: validateConstant.LENGTH.郵便番号,
      }),
    },
    電話番号: {
      type: "string",
      maxLength: validateConstant.LENGTH.電話番号,
      nullable: true,
      title: "電話番号",
      errorMessage: util.stringErrorMessage("電話番号", {
        maxLength: validateConstant.LENGTH.電話番号,
      }),
    },
    FAX番号: {
      type: "string",
      maxLength: validateConstant.LENGTH.電話番号,
      nullable: true,
      title: "FAX番号",
      errorMessage: util.stringErrorMessage("FAX番号", {
        maxLength: validateConstant.LENGTH.電話番号,
      }),
    },
    客先台帳ファイル名: {
      type: "string",
      maxLength: validateConstant.LENGTH.一般名称,
      nullable: true,
      title: "客先台帳ファイル名",
      errorMessage: util.stringErrorMessage("客先台帳ファイル名", {
        required: false,
        maxLength: validateConstant.LENGTH.一般名称,
      }),
    },
    客先台帳: {
      type: "object",
      nullable: true,
      title: "客先台帳",
    },
    積卸先担当者: {
      type: "string",
      maxLength: validateConstant.LENGTH.一般名称,
      nullable: true,
      title: "積卸先担当者",
      errorMessage: util.stringErrorMessage("積卸先担当者", {
        required: false,
        maxLength: validateConstant.LENGTH.一般名称,
      }),
    },
    更新日時: {
      type: "string",
      title: "更新日時",
    },
  },
  required: [
    "荷主コード",
    "積卸先コード",
    "積卸先名",
    "都道府県コード",
    "更新日時",
  ],
  errorMessage: {
    required: util.JsonSchemeRequiredErrorMessages([
      "荷主コード",
      "積卸先コード",
      "積卸先名",
      "都道府県コード",
      "更新日時",
    ]),
  },
}
